<template>
  <form class="card rounded-top" @submit.prevent="save">
    <div class="row card-body ">
      <div class="form-group col-xs-12 col-md-6">
        <w-input :model="$schema.name" :title="$t($schema.name.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <w-input :model="$schema.acceptText" :title="$t($schema.acceptText.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <form-datepicker :model="$schema.start" :title="$t($schema.start.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <w-input :model="$schema.order" :title="$t($schema.order.$schema.title)" />
      </div>

      <div class="form-group col-12">
        <w-checkbox :model="$schema.required" :title="$t($schema.required.$schema.title)" />
      </div>

      <div class="form-group col-12">
        <w-textarea :model="$schema.content" :title="$t($schema.content.$schema.title)" />
      </div>

      <div class="col-12 text-right  card-actions">
        <button class="btn btn-dark btn-lg rounded-pill" @click.prevent="cancel">
          {{ $t('buttons.cancel') }}
        </button>

        <button type="submit" class="btn btn-smart btn-lg rounded-pill">{{ $t('buttons.save') }}</button>
      </div>
    </div>
  </form>
</template>

<script>
import { formViewMixin } from '@/mixins/formView';
import schema from '@/schemas/terms.schema';

const emptyData = () => ({
  name: '',
  order: null,
  required: false,
  content: '',
  start: ''
});

const messages = {
  added: 'messages.terms.added',
  addError: 'messages.terms.addError',
  updated: 'messages.terms.updated',
  updateError: 'messages.terms.updateError'
};

// @vuese
// Formularz regulaminów
// @group Terms
export default {
  schema,
  mixins: [formViewMixin('terms', messages, emptyData)]
};
</script>